import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signOut,
  updateProfile
} from 'firebase/auth'
import { doc, setDoc } from 'firebase/firestore'
import { auth, db } from './config'
import { createSite } from './siteProfile'

// Sign up a new site researcher (basic account)
export const signupResearcher = async (email, password) => {
  try {
    // Create auth account
    const userCredential = await createUserWithEmailAndPassword(auth, email, password)
    const user = userCredential.user

    // Create basic user document
    await setDoc(doc(db, 'users', user.uid), {
      email: user.email,
      role: 'researcher',
      createdAt: new Date()
    })

    return { success: true, user }
  } catch (error) {
    console.error('Error in signupResearcher:', error)
    let errorMessage = 'Failed to create account'
    
    // Handle specific Firebase auth errors
    switch (error.code) {
      case 'auth/email-already-in-use':
        errorMessage = 'This email is already registered. Please try signing in instead.'
        break
      case 'auth/invalid-email':
        errorMessage = 'Please enter a valid email address.'
        break
      case 'auth/weak-password':
        errorMessage = 'Password should be at least 6 characters long.'
        break
      case 'auth/operation-not-allowed':
        errorMessage = 'Email/password accounts are not enabled. Please contact support.'
        break
    }
    
    return { 
      success: false, 
      error: errorMessage,
      code: error.code 
    }
  }
}

// Sign in
export const signin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    return { success: true, user: userCredential.user }
  } catch (error) {
    console.error('Error in signin:', error)
    return { 
      success: false, 
      error: error.message || 'Failed to sign in' 
    }
  }
}

// Sign out
export const signout = async () => {
  try {
    await signOut(auth)
    return { success: true }
  } catch (error) {
    console.error('Error in signout:', error)
    return { 
      success: false, 
      error: error.message || 'Failed to sign out' 
    }
  }
}
